import { FreeZonePlateValue } from '@/common/components/base/input/plate/freeZonePlateInput/freeZonePlateInput.type';
import { plateValue } from '@/common/components/base/input/plate/vehiclePlateInput/vehiclePlateInput.type';
import { SelectionOptionsType } from '@/common/types/SelectionOptions.type';

export type VehicleInformationType = Partial<{
  vehicle_type: number | null;
  vehicle_model: number | null;
  vehicle_use: number | null;
  vehicle_plate_type: number | null;
  vehicle_plate_design: string | null;
  vehicle_plate_sample: number | null;
  vehicle_plate: string | null;
  vehicle_manufacturing_year: string | null;
  vehicle_color: number | null;
  vehicle_vin: string | null;
  vehicle_chassis: string | null;
  vehicle_engine: string | null;
  vehicle_price?: number | null;
  fault_percentage?: number | null;
  vehicle_fuel: string | null;
  property_insurance: {
    insurance: number | null;
    insurance_number: string | null;
    insurance_start_date: string | null;
    insurance_expiry_date: string | null;
    insurance_expiry_date_last_year: string | null;
  };
  vehicle_insurance_extended?: boolean;
}>;

export type VehicleInformationFormType = Partial<{
  vehicle_type: SelectionOptionsType<number> | null;
  vehicle_model: SelectionOptionsType<number> | null;
  vehicle_use: SelectionOptionsType<number> | null;
  vehicle_plate_type: SelectionOptionsType<number> | null;
  vehicle_plate_sample: SelectionOptionsType<number> | null;
  vehicle_plate_design: SelectionOptionsType<string> | null;
  vehicle_plate: plateValue & FreeZonePlateValue;
  vehicle_manufacturing_year: SelectionOptionsType<string> | null;
  vehicle_color: SelectionOptionsType<number> | null;
  vehicle_vin: string | null;
  vehicle_chassis: string | null;
  vehicle_engine: string | null;
  vehicle_price?: number | null;
  fault_percentage?: number | null;
  vehicle_fuel?: SelectionOptionsType<string> | null;
  vehicle_seat?: number | null;
  vehicle_cylinder?: number | null;
  vehicle_insurance_extended?: boolean;
}>;
export type VehicleInformationPartOneFormType = Pick<
  VehicleInformationFormType,
  | 'vehicle_type'
  | 'vehicle_use'
  | 'vehicle_model'
  | 'vehicle_plate_type'
  | 'vehicle_plate_design'
  | 'vehicle_plate_sample'
  | 'vehicle_plate'
  | 'vehicle_fuel'
  | 'vehicle_insurance_extended'
>;
export type VehicleDamagedInformationPartTwoFormType = Omit<
  VehicleInformationFormType,
  'vehicle_price'
> & { vehicle_price?: string | null };

export type VehicleCulpritInformationPartTwoFormType = Pick<
  VehicleInformationFormType,
  | 'vehicle_manufacturing_year'
  | 'vehicle_color'
  | 'vehicle_vin'
  | 'vehicle_chassis'
  | 'vehicle_engine'
  | 'vehicle_cylinder'
>;

export type VehicleInitialInformationPartTwoFormType = Omit<
  VehicleInformationFormType,
  'vehicle_price'
> & { vehicle_price?: string | null };

export enum VehicleInformationEnum {
  damaged = 'damaged',
  culprit = 'culprit',
  initial = 'initial',
}
